
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { NgbDropdownModule, NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-pagination-controls',
    templateUrl: './pagination-controls.component.html',
    styleUrls: ['./pagination-controls.component.css'],
    imports: [
    NgbPaginationModule,
    NgbDropdownModule
],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})

export class PaginationControlsComponent {
    @Input() totalRows: number = 0;
    @Input() currentPage: number = 1;
    @Input() pageSize: number = 20;
    public pageSizeOptions: number[] = [10, 20, 50, 100];

    @Output() currentPageChange = new EventEmitter<number>();
    @Output() currentPageSize = new EventEmitter<number>();

    totalPages = (): number => Math.ceil(this.totalRows / this.pageSize);

    onPageSizeChange(size: number)
    {
        this.pageSize = size;
        this.currentPage = 1;
        this.currentPageSize.emit(this.pageSize);
        this.currentPageChange.emit(1);
    }

    onPageChange(page:number)
    {
        this.currentPage = page;
        this.currentPageChange.emit(this.currentPage);
    }

    calculateStartIndex()
    {
        if (this.totalRows == 0)
            return 0;
        if (this.currentPage == 1)
            return 1;

        return (this.currentPage * this.pageSize) - this.pageSize;
    }

    calculateTotalRowsOnPage()
    {
        if (this.currentPage * this.pageSize >= this.totalRows)
        {
            return this.totalRows;
        }

        return this.currentPage * this.pageSize;
    }
}